import {html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import deepEqual from 'deep-equal';
import {msg} from '@lit/localize';
import style from '../../../../../scss/space.scss';
import {FormElement} from '../form/formElement';

@customElement('arc-diagonal')
export class Diagonal extends FormElement {
	static properties = {
		value: {type: Object, hasChanged: (n, o) => !deepEqual(n, o)},
		errors: {type: Array, hasChanged: (n, o) => !deepEqual(n, o)},

		index: {type: Number},
		type: {type: String},
	};

	static styles = [...FormElement.styles, style];

	units = [
		{id: 'mm', name: 'mm'},
		{id: 'cm', name: 'cm'},
		{id: 'm', name: 'm'},
		{id: 'in', name: 'in'},
		{id: 'ft', name: 'ft'},
	];

	initialValue = {
		type: 'diagonal',
		title: [],
		value: {
			unit: 'cm',
			value: '',
		},
	};

	titleChange(value) {
		this.inputValue.title = value;
		this.dispatchValueChange(this.inputValue);
	}
	inputValueValue(value) {
		this.inputValue.value.value = value;
		this.dispatchValueChange(this.inputValue);
	}
	selectValueUnit(value) {
		this.inputValue.value.unit = value;
		this.dispatchValueChange(this.inputValue);
	}

	render() {
		return html`
			<div class="space">
				<div class="dimensions">
					<div class="dimension">
						<div class="formContainer">
							<arc-text-input
								class="value"
								id="value"
								class="formInput width"
								.title="${msg('Length')}"
								?disabled="${this.disabled}"
								.multiline=${false}
								.value=${this.inputValue.value.value}
								.errors=${this.errors?.params?.value?.params?.value?.errors || []}
								.required=${true}
								@value-change=${(e) => this.inputValueValue(e.detail.value)}
							></arc-text-input>
							<arc-select
								class="unit"
								.title=""
								?disabled="${this.disabled}"
								.value=${this.inputValue.value.unit}
								.errors=${this.errors?.params?.value?.params?.unit?.errors || []}
								.options=${this.units}
								.required=${true}
								@value-change=${(e) => this.selectValueUnit(e.detail.value)}
							>
							</arc-select>
						</div>
					</div>
				</div>
				<arc-multilingual-input
					.title=${msg('Explanation')}
					.value=${this.inputValue.title}
					.errors=${this.errors?.params?.title}
					?disabled="${this.disabled}"
					.required=${false}
					.multiline=${false}
					@value-change=${(e) => this.titleChange(e.detail.value)}>
				</arc-multilingual-input>
			</div>
		`;
	}
}
